import { FC, useEffect, useState } from "react"
import { usePluginspace } from "../../hooks/usePluginspace";
import SuccessImg from "../../assets/images/success-order.svg";
import SuccessImgFood from "../../assets/images/success-food.svg";
import { FaBoxOpen } from "react-icons/fa";
import styles from './index.module.css'


type StatusResponseType = {
  id: number;
  name: string;
  slug: string;
  order: number;
  displayStatusWebapp: boolean;
};

type RenderStatusType = StatusResponseType & {
  label: string;
};



type Props = {
  externalCodeERP: string
  orderIdExt: string
  status?: StatusResponseType[]
  statusOrder?: StatusResponseType
  config: any
  type: string
}

const InfoFinishedOrder: FC<Props> = ({ orderIdExt, externalCodeERP, status, statusOrder, config, type }) => {
  const [typePluginSpace, setTypePluginSpace] = useState<string>('')
  const { getThisPluginspace } = usePluginspace();


  async function getInfoPluginSpace() {
    try {
      const type = await getThisPluginspace();

      setTypePluginSpace(type!.type);
    } catch (error) {

    }
  }

  useEffect(() => {
    getInfoPluginSpace()
  }, [])

  const getStatusLabel = (oneStatus: StatusResponseType) => {
    if (oneStatus.slug === 'order_delivered' && type === 'withdraw') {
      return 'Retirado';
    }

    if (oneStatus.slug === 'packaged' && type === 'withdraw') {
      return 'Pronto para retirar';
    }

    return oneStatus.name;
  };

  const statusToRender: RenderStatusType[] = type === 'counter'
    ? (status ?? [])
      .filter((oneStatus) => oneStatus.order === 4 || oneStatus.order === 5)
      .map((oneStatus) => ({
        ...oneStatus,
        label: oneStatus.order === 4 ? 'Recepcionado' : 'Concluído'
      }))
    : (status ?? []).map((oneStatus) => ({
      ...oneStatus,
      label: getStatusLabel(oneStatus)
    }));

  const fontStatusStyle = config?.webappcolor?.fontstatus
    ? { color: config.webappcolor.fontstatus }
    : {};

  const getItemBackgroundStyle = (isActive: boolean) => {
    if (isActive && config?.webappcolor?.backgroundstatusactive) {
      return { backgroundColor: config.webappcolor.backgroundstatusactive };
    }

    if (!isActive && config?.webappcolor?.backgroundstatus) {
      return { backgroundColor: config.webappcolor.backgroundstatus };
    }

    return {};
  };

  return (
    <div className={styles.content}>
     
      <div className={styles.content_image}>
        {typePluginSpace === 'food' ?
          <img src={SuccessImgFood} alt="Pedido enviado" />
          :
          <img src={SuccessImg} alt="Pedido enviado" />
        }
      </div>
      <div className={styles.content_title}>
        <h4>O seu pedido foi finalizado.</h4>
      </div>
      <div className={styles.content_order} >
        <FaBoxOpen color="#5D8ED8" size={20} />
        <h4> Pedido {externalCodeERP ? externalCodeERP : orderIdExt}</h4>
      </div>

      <div className={styles.content_status_body}>
        <div className={styles.content_status}>
          {statusToRender.map((oneStatus, index) => {
            const isActive = oneStatus.id === statusOrder?.id;
            const isFirst = index === 0;
            const isLast = index === statusToRender.length - 1;

            return (
              <div
                key={oneStatus.id}
                className={[
                  isActive ? styles.status_active : styles.status,
                  isFirst ? styles.success_extreme_left : '',
                  isLast ? styles.success_extreme_right : ''
                ].join(' ').trim()}
                style={getItemBackgroundStyle(isActive)}
              >
                <p style={fontStatusStyle}>{oneStatus.label}</p>
              </div>
            );
          })}
        </div>
      </div>

    </div>
  )
}

export { InfoFinishedOrder }